<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">Add a new app layout</span>
    </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ e[0] }}
        </v-alert>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="appLayout.name"
          :rules="rules.required"
          label="Name *"
        ></v-text-field>

        <v-text-field
          v-model="appLayout.instance"
          :rules="rules.required"
          label="Instance *"
        ></v-text-field>

        <v-text-field
          v-model="appLayout.primary_color"
          :rules="rules.required"
          label="Primary color *"
        ></v-text-field>

        <v-text-field
          v-model="appLayout.secondary_color"
          :rules="rules.required"
          label="Secondary color *"
        ></v-text-field>

        <v-text-field
          v-model="appLayout.emails"
          hint="services@bonacasa.ch; alexey.moroz@bonacasa.ch"
          label="Emails"
        ></v-text-field>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">Cancel</v-btn>
            <v-btn outlined text @click="reset">Reset form</v-btn>
            <v-btn color="success" :disabled="!valid" @click="validate">
              Create
            </v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AppLayoutsCreate',

  data: () => ({
    appLayout: {},
    error: null,

    valid: true,
    rules: {
      required: [v => !!v || 'Field is required']
    }
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('app_layout/store', {
            app_layout: this.appLayout
          })
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
            this.reset();
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    },

    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>
